// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1kpOP","title":"AfterFrontImage_title__1tOkQ"};